import React from "react";

import Input from "./Input";
import DateControl from "./Date";
import DateSelect from "./DateSelect";
import Select from "./Select";
import Checkbox from "./Checkbox";
import TextArea from "./TextArea";
import st from "lib/utils/index";
import ProductPickupPointInfo from "lib/components/ProductPickupPointInfo";
import AppSettings from "lib/services/AppSettings";

export default function OrderedProductOrderField({
  name,
  value: orderedField,
  onFocus,
  onChange,
  onBlur,
  label,
  help,
  required,
}) {
  const defaultValuesEnables = st.authorize.company.reseller || st.authorize.company.agent;

  const field = orderedField.product_order_field;
  label = label !== undefined ? label : field.type !== "ProductOrderField::Boolean" && field.display_name_with_price;
  help = help !== undefined ? help : field.type !== "ProductOrderField::Boolean" && field.customer_hint;
  required = required !== undefined ? required : field.order_value_required;

  const default_email = defaultValuesEnables ? st.authorize.user.email : "";

  const default_phone_number = defaultValuesEnables ? st.authorize.company.contact_phone_number : "";

  const default_name = defaultValuesEnables ? st.authorize.company.name : "";

  switch (field.type) {
    case "ProductOrderField::Text":
      // hack to trigger native change event for the input default value - needed for resellers and agents
      const vvame = orderedField.value || default_name;
      setTimeout(() => {
        var input = document.querySelector("#naame");

        if (input && !input.value && !input.dataset.touched) {
          input.dataset.touched = true;
          var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
          nativeInputValueSetter.call(input, vvame);

          var inputEvent = new Event("input", { bubbles: true });
          input.dispatchEvent(inputEvent);
        }
      }, 1);

      return (
        <Input
          id={"naame"}
          name={name}
          value={orderedField.value || ""}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange && ((value) => onChange({ ...orderedField, value }))}
          required={required}
        />
      );
    case "ProductOrderField::Email":
      // hack to trigger native change event for the input default value - needed for resellers
      const v = orderedField.value || default_email;
      setTimeout(() => {
        var input = document.querySelector("#eemail");

        if (input && !input.value && !input.dataset.touched) {
          input.dataset.touched = true;
          var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
          nativeInputValueSetter.call(input, v);
          var inputEvent = new Event("input", { bubbles: true });
          input.dispatchEvent(inputEvent);
        }
      }, 1);

      return (
        <Input
          type="email"
          name={name}
          id={"eemail"}
          value={orderedField.value || " "}
          onFocus={onFocus}
          onChange={onChange && ((value) => onChange({ ...orderedField, value }))}
          required={required}
        />
      );
    case "ProductOrderField::PhoneNumber":
      const telValue = orderedField.value || default_phone_number;
      setTimeout(() => {
        var input = document.querySelector("#teel");

        if (input && !input.value && !input.dataset.touched) {
          input.dataset.touched = true;
          var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
          nativeInputValueSetter.call(input, telValue);

          var inputEvent = new Event("input", { bubbles: true });
          input.dispatchEvent(inputEvent);
        }
      }, 1);
      return (
        <Input
          type="tel"
          id={"teel"}
          name={name}
          value={orderedField.value || ""}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange && ((value) => onChange({ ...orderedField, value }))}
          required={required}
        />
      );
    case "ProductOrderField::Date":
      return (
        <DateSelect
          id={name}
          name={name}
          value={orderedField.value || ""}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange && ((value) => onChange({ ...orderedField, value }))}
          required={required}
        />
      );
    case "ProductOrderField::BigText":
      return (
        <TextArea
          rows="3"
          id={name}
          name={name}
          value={orderedField.value || ""}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange && ((value) => onChange({ ...orderedField, value }))}
          required={required}
          autoHeight
        />
      );
    case "ProductOrderField::Country":
      return (
        <Select
          id={name}
          name={name}
          value={orderedField.value || ""}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange && ((value) => onChange({ ...orderedField, value }))}
          required={required}
          options={AppSettings.countries}
          includeBlank
          search
        />
      );
    case "ProductOrderField::Boolean":
      return (
        <div>
          <Checkbox
            key="checkbox"
            id={name}
            name={name}
            label={label}
            value={orderedField.value}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange && ((value) => onChange({ ...orderedField, value }))}
            required={required}
          />
          {!!help && (
            <div key="help" className="ui help">
              {help}
            </div>
          )}
        </div>
      );
    case "ProductOrderField::Number":
      return (
        <Select
          compact
          id={name}
          name={name}
          value={orderedField.value || field.min_value || 0}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange && ((value) => onChange({ ...orderedField, value: +value }))}
          options={st
            .range(field.min_value || 0, field.max_value || (field.min_value || 0) + 1000000, true)
            .map((i) => [i, i])}
          required={required}
        />
      );
    case "ProductOrderField::List":
      return (
        <Select
          compact
          className="u-dropdownMenuHugeWidth u-dropdownMenuWsWrap"
          id={name}
          name={name}
          value={(orderedField.value && orderedField.value.id) || ""}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={
            onChange &&
            ((value) =>
              onChange({
                ...orderedField,
                value: field.list_options.find((lo) => lo.id === +value),
                value_obj: undefined,
              }))
          }
          includeBlank
          options={field.list_options.map((list_option) => [
            list_option.id,
            list_option.display_name_with_price(field),
          ])}
          required={required}
        />
      );
    case "ProductOrderField::PickupPoint":
      setTimeout(() => {
        if (!defaultValuesEnables) {
          return;
        }
        // if hotel pickup (custom pickup point) id available - select it.
        const customPickupArr = field.pickup_point_options.filter((p) => p.pickup_point_type === "custom");

        if (customPickupArr.length && !orderedField.value) {
          onChange({
            ...orderedField,
            value: {
              ...orderedField.value,
              pickup_point_option_id: customPickupArr[0].id,
              pickup_point_option: customPickupArr[0],
            },
            value_obj: undefined,
          });
        }

        // if custom pickup point is selected - fill it with company name and address
        var input = document.querySelector("#customLocationName");
        if (!input) {
          return;
        }
        if (input && !input.value && !input.dataset.touched) {
          const locValue = st.authorize.company.location_name
            ? `${st.authorize.company.name}, ${st.authorize.company.location_name}`
            : "";
          input.dataset.touched = true;
          var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
          nativeInputValueSetter.call(input, locValue);

          var inputEvent = new Event("input", { bubbles: true });
          input.dispatchEvent(inputEvent);
        }
      }, 1);

      return (
        <div>
          <Select
            compact
            className="u-dropdownMenuHugeWidth u-dropdownMenuWsWrap"
            id={name}
            name={name}
            value={(orderedField.value && orderedField.value.pickup_point_option_id) || ""}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={
              onChange &&
              ((value) =>
                onChange({
                  ...orderedField,
                  value: value
                    ? {
                        ...orderedField.value,
                        pickup_point_option_id: +value,
                        pickup_point_option: field.pickup_point_options.find((option) => option.id === +value),
                      }
                    : null,
                  value_obj: undefined,
                }))
            }
            includeBlank
            options={field.pickup_point_options.map((option) => [option.id, option.display_name_with_price(field)])}
            required={required}
          />
          {orderedField.value && orderedField.value.pickup_point_option.pickup_point_type === "custom" && (
            <div className="u-marginTop">
              <Input
                value={orderedField.value.custom_location_name || ""}
                onFocus={onFocus}
                onBlur={onBlur}
                id={"customLocationName"}
                onChange={
                  onChange &&
                  ((custom_location_name) =>
                    onChange({
                      ...orderedField,
                      value: { ...orderedField.value, custom_location_name },
                      value_obj: undefined,
                    }))
                }
                required={required}
                placeholder={I18n.t(
                  "papp.components.OrderedProductOrderFieldFormControl.custom_location_name_placeholder"
                )}
              />
            </div>
          )}
          {orderedField.value && orderedField.value.pickup_point_option.pickup_point_type === "predefined" && (
            <div className="u-marginTop" style={{ lineHeight: "1.5" }}>
              <ProductPickupPointInfo
                point={orderedField.value.pickup_point_option.product_pickup_point}
                showName={false}
              />
            </div>
          )}
        </div>
      );
    default:
      throw `Unknown orderedField.product_order_field.type: ${field.type}`;
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/OrderedProductOrderField.jsx